var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "Z-Wave",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    d: "M4 5h12.6L8.2 16.2H16V19H3.6l8.4-11.2H4zm15.05 2.6c-.86 0-1.58.3-2.15.89-.57.6-.86 1.35-.86 2.28 0 .91.29 1.66.86 2.24.57.59 1.29.88 2.15.88.85 0 1.56-.29 2.13-.88.57-.58.86-1.33.86-2.24 0-.93-.29-1.68-.86-2.28-.57-.59-1.28-.89-2.13-.89zm-.03 1.48c.41 0 .75.14 1.03.43.28.29.43.66.43 1.1 0 .43-.15.79-.43 1.07-.28.28-.62.42-1.03.42s-.76-.14-1.04-.42c-.27-.28-.41-.64-.41-1.07 0-.44.14-.81.41-1.1.28-.29.63-.43 1.04-.43zm.58 6.03h1.73L18.4 19h-1.72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZWave);
export default __webpack_public_path__ + "static/media/z-wave.a1232b80f0162f57a1aff41d059ebacd.svg";
export { ForwardRef as ReactComponent };